import React from "react";
import BasicCustomTable from "../../../component/basicTable";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { getServiceManagementPermissions } from "../../../utils/rolesAndPermissions";

export default function ViewAll({ dialogDetails, onClose, onDelete }) {
    const permissions = useSelector((state) => state.counter.permissions);
    const rolePermissions = permissions?.[0]?.permissions || [];
    const { canCreate, canDelete } =
      getServiceManagementPermissions(rolePermissions);
  
    const finalColumns = React.useMemo(() => {
      if ( !canDelete) {
        return dialogDetails.columns.filter((col) => col.field !== "action");
      }
      return dialogDetails.columns;
    }, [canDelete]);

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <div className="flex justify-center w-full text-lg font-[500]">
          {dialogDetails.content.title}
        </div>
        <button
          className=" text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
      <div className="my-4">
        <BasicCustomTable
          columns={finalColumns}
          rows={dialogDetails.content.rows}
          colorHeader={false}
          onDelete={onDelete}
          customClassHeader={"table-header-center"}
          tableName={dialogDetails.content.label}
          maxHeightClass="max-h-[calc(100vh-325px)]"
          frontendPagination={true}
           pageLimit={10}
           canDelete={canDelete}
        />
      </div>
    </div>
  );
}
